import { useRecordingStore, useRecordingTimer } from '@/entities/audio-recording';
import { Timer } from '@/shared/ui/indicators/timer';

export function RecordingCaptureTimer() {
    const { elapsedTime } = useRecordingTimer();
    const status = useRecordingStore((state) => state.status);
    return (
        <Timer
            time={elapsedTime}
            className={status === 'recording' ? 'text-base-foreground' : 'text-muted-foreground'}
        />
    );
}
